.SurveyControlButtonContainer {
    margin-top: 1em;
    margin-bottom: 1em;
    position: relative;
    z-index: 1;
    width: 100%;
}

.CarouselOuterWrapper {
    position: relative;
    z-index: 10;
    width: 100%;
}

.CarouselInnerWrapper {
    height: fit-content;
    width: 100%;
}

.QuestionsRow {
    --bs-gutter-y: 2rem;
}
